import EventNoteIcon from "@mui/icons-material/EventNote";
import CustomTooltip from "../../ui/CustomTooltip";
import {
  formatHistoryEntry,
  getHistoryTone,
  translateText,
} from "../../../../shared/utils/historyTranslation";

export default function HistorialControl({ historialControl = [], translate }) {
  const items = Array.isArray(historialControl) ? historialControl : [];

  return (
    <div className="historialCard">
      {/* <CustomTooltip
        variant="pipeline"
        title={translateText(translate, "history_control_title", "Historial de Control")}
        color="#c3c3c3"
        arrow
      > */}
        <button
          type="button"
          className="icon-btn historial-main"
          aria-label={translateText(translate, "history_control_title", "Historial de Control")}
        >
          <EventNoteIcon className="icon" />
        </button>
      {/* </CustomTooltip> */}

      <div className="historial-panel">
        <div className="history-title">
          {translateText(translate, "history_control_title", "Historial de Control")}
        </div>

        <div className="lower list-historial">
          {items.length ? (
            items.map((item, index) => {
              const entry = formatHistoryEntry(item, translate);
              const tone = getHistoryTone(item?.accion, item?.descripcion, item?.msg);

              return (
                <div key={`${entry.fecha}-${index}`} className="history-item">
                  <div className="history-info">
                    {entry.preferCombinedMessage ? (
                      <span className="descripcion">{entry.message}</span>
                    ) : entry.isStructured ? (
                      <>
                        {entry.responsable ? (
                          <span className="responsable">{entry.responsable}</span>
                        ) : null}
                        {entry.accion ? (
                          <span className="accion" style={{ color: tone }}>
                            {entry.accion}
                          </span>
                        ) : null}
                        {entry.descripcion ? (
                          <span className="descripcion">{entry.descripcion}</span>
                        ) : null}
                        {entry.ubicacion ? (
                          <span className="ubicacion">{entry.ubicacion}</span>
                        ) : null}
                      </>
                    ) : (
                      <span className="descripcion">{entry.message}</span>
                    )}
                  </div>

                  {entry.fecha ? <span className="fecha">{entry.fecha}</span> : null}
                </div>
              );
            })
          ) : (
            <div className="sin-datos">
              {translateText(
                translate,
                "sin_datos_historial",
                "No hay datos de historial para mostrar"
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
